// @flow
import React from 'react'
import RefreshAnalysisButton from '../../../containers/shared/Header/RefreshAnalysisButtonContainer'
import AnalysisStatus from '../../../containers/shared/Header/AnalysisStatusContainer'

type Props = {
  model: Object,
  defaultBranch: string,
  branchName: string,
  currentAccount: Object
}

export default class PRMetaData extends React.Component<Props> {
  render () {
    return (
      <div style={{marginLeft: 'auto'}}>
        <div style={{textAlign: 'right'}}>
          {this.props.defaultBranch} &larr; {this.props.branchName}
        </div>
        <div style={{display: 'flex', alignItems: 'top'}}>
          <AnalysisStatus />
          <RefreshAnalysisButton
            model={this.props.model}
            currentAccount={this.props.currentAccount}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/components/pull_request/Header/PRMetaData.js